import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

type FeatureEstimateAllResponse = {
  "event": string,
  "event_name": string,
  "estimate": number
}[]

export class FeatureEstimateAllData {
  @Required("event cannot be empty")
  @IsString("event must be a string")
  event: string;

  @Required("event name cannot be empty")
  @IsString("event name must be a string")
  eventName: string;

  @Required("estimate cannot be empty")
  @IsNumber("estimate must be a number")
  estimate: number;
}

const transformAndValidateData = (
  response: FeatureEstimateAllResponse
): FeatureEstimateAllData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, FeatureEstimateAllData);
  } catch (error) {
    console.error("Feature estimate all data validation failed:", error.message);
    throw error;
  }
};

/** 获取短视频、Ai创作、图文、文章、播客（包含口播模式）、朋友圈的消耗积分数 */
export const featureEstimateAll = async ({
  pid,
  featureCode,
}: {
  pid: number;
  featureCode: string;
}): Promise<FeatureEstimateAllData[]> => {
  const res = await api.get<FeatureEstimateAllResponse[]>('/feature/estimate/all', {
    pid,
    feature_code: featureCode,
  });
  const data = res.data.map(transformAndValidateData);
  return data;
}